import { ContactDetailsSession } from "./contactDetailsSession";
import { LocationDetailsSession } from "./locationDetailsSession";
import { PlacardDetailsSession } from "./placardDetailsSession";
import { PickupDetailsSession } from "./pickupDetailsSession";
import { NotificationDetailsSession } from "./notificationDetailsSession";
import { CreatePickUpSession } from "./CreatePIckUpSession";
import { Error } from '../../interface/upplm.common.interface';
import { PlacardConfirmationSession } from "./placardConfirmationSession";
import { PlacardLocationSession } from "./PlacardLocationSession";

export class SessionResponse {
    key: string;
    placardStatus: string;
    locationDetails: LocationDetailsSession;
    temporaryLocation: LocationDetailsSession;
    contactDetails: ContactDetailsSession;
    placardDetails: PlacardDetailsSession;
    pickupDetails: PickupDetailsSession;
    notificationDetails: NotificationDetailsSession;
    createPickUp: CreatePickUpSession;
    commonResponse: CommonResponseModal;
    lastTimeSessionReqired: string;
    errors: Error;
    placardConfirmation: PlacardConfirmationSession;
    placardLocation: PlacardLocationSession;
    comesFromReview: boolean;
    backBrowserPage: string;
    placardID: string;
    isApproved: boolean;
}

export class CommonResponseModal {
    code: string;
    description: string;
    isSuccess: boolean;
    codeLeveError: string;
    isError: boolean;
    alertCode: string;
    alertDescription: string;
}